<template>
  <div class="wl-study-source-wrapper">
    <div class="study-nav-con"
         :style="{backgroundImage: 'url(' + siteNavBgImg + ')'}"></div>
    <div class="certify-site-con">
      <div class="certify-site-head">
        <i class="wl-icon-zhuye1"></i>
        <span class="sp-now-position">当前位置:</span>
        <span class="sp-to-home"
              @click="toHomePage">首页</span>
        <span class="sp-head-line">></span>
        <span>站点</span>
      </div>
    </div>
    <div class="certify-site-list clearfix">
      <div class="all-site-title">
        学习资源
      </div>
      <div class="sub-head-title">LEARNING RESOURCE</div>
      <div class="retrieval-source-list">
        <div class="re-source-head clearfix">
          <span class="sp-publish-time">出版时间:</span>
          <span class="sp-seletc-year"
                @click="getAllSource"
                :class="{selectYearActive:allSourceActive == 'all'}">全部</span>
          <span v-for="item in yearList"
                :key="item"
                class="sp-seletc-year"
                :class="{selectYearActive:yearActiveIndex == item}"
                @click="getYearSource(item)">
            {{item}}年
          </span>
          <span class="sp-seletc-year"
                @click="getOldSource"
                :class="{selectYearActive:oldSourceActive == 'old'}">{{endYearVal}}年以前</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      siteNavBgImg: require("assets/images/certify-site-img.png"),
      yearList: [],
      endYearVal: "",
      allSourceActive: "all",
      oldSourceActive: "",
      yearActiveIndex: ""
    };
  },
  created() {
    let date = new Date();
    let year = date.getFullYear();
    let endYear = year - 7;
    this.endYearVal = endYear;
    for (let i = 0; i < 8; i++) {
      this.yearList.push(year - i);
    }
    console.log(this.yearList);
  },
  methods: {
    toHomePage() {
      this.$router.push({
        name: "xHome"
      });
    },
    getAllSource() {
      this.allSourceActive = "all";
      this.oldSourceActive = "old";
      this.yearActiveIndex = "";
    },
    getYearSource(index) {
      this.allSourceActive = "";
      this.oldSourceActive = "";
      this.yearActiveIndex = index;
    },
    getOldSource() {
      this.allSourceActive = "";
      this.oldSourceActive = "old";
      this.yearActiveIndex = "";
    }
  }
};
</script>

<style>
</style>
